import { render, staticRenderFns } from "./thong-tin-lien-he.vue?vue&type=template&id=23073440&"
import script from "./thong-tin-lien-he.vue?vue&type=script&lang=js&"
export * from "./thong-tin-lien-he.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports